import { IPublicClientApplication } from '@azure/msal-browser';

export default async function getAccessToken(pca: IPublicClientApplication) {
    const accounts = pca.getAllAccounts();
    if (accounts.length === 0) {
        return null;
    }

    const request = {
        scopes: [`api://${import.meta.env.VITE_WEB_CLIENT_ID}/Files.Read`], // SERVER_ID
        account: pca.getActiveAccount() ?? accounts[0]
    };

    try {
        const token = await pca.acquireTokenSilent(request);
        return token.accessToken;
    } catch {
        // Cached access token expired — retry using the refresh token
        try {
            const token = await pca.acquireTokenSilent({ ...request, forceRefresh: true });
            return token.accessToken;
        } catch (retryError) {
            console.warn('getAccessToken: silent acquisition failed after forceRefresh retry', retryError);
            return null;
        }
    }
}
